import { createContext, useContext, useState, useEffect } from 'react';
import { adminLogin as apiLogin, adminLogout as apiLogout } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token,  setToken]  = useState(() => localStorage.getItem('aurora_admin_token') || '');
  const [email,  setEmail]  = useState(() => localStorage.getItem('aurora_admin_email') || '');
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const isAuthenticated = !!token;

  async function login(emailInput, password) {
    setLoading(true);
    setError('');
    try {
      const res = await apiLogin(emailInput, password);
      setToken(res.token);
      setEmail(res.email);
      localStorage.setItem('aurora_admin_token', res.token);
      localStorage.setItem('aurora_admin_email', res.email);
      return true;
    } catch (err) {
      setError(err.message || 'Login failed');
      return false;
    } finally {
      setLoading(false);
    }
  }

  async function logout() {
    await apiLogout().catch(() => null);
    setToken('');
    setEmail('');
    localStorage.removeItem('aurora_admin_token');
    localStorage.removeItem('aurora_admin_email');
  }

  return (
    <AuthContext.Provider value={{ token, email, isAuthenticated, loading, error, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }